import { IUsernameMap } from "../../model/OpenCab";
import { createAction, ActionsUnion } from "../definitions";
import { OpenCabUsersActionTypes } from "./types";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const OpenCabUserActions = {
    clearOpenCabUser: (payload: string) => createAction(OpenCabUsersActionTypes.CLEAR_OPENCABUSER, payload),
    setOpenCabUser: (payload: IUsernameMap) => createAction(OpenCabUsersActionTypes.SET_OPENCABUSER, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OpenCabUserActions = ActionsUnion<typeof OpenCabUserActions>;